import React from 'react';
import { Link } from 'react-router-dom';
import { MdSearchOff } from 'react-icons/md';

const NotFoundPage = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '70vh',
      }}
    >
      <div className="text-center">
        <div style={{ marginBottom: '16px', color: '#dc3545' }}>
          <MdSearchOff size={80} />
        </div>
        <h1 style={{ fontWeight: 'bold', marginBottom: '16px' }}>
          Página no encontrada
        </h1>
        <p style={{ marginBottom: '24px' }}>
          La página que busca no existe.
        </p>
        <Link to="/" className="btn btn-primary">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
